import { render, staticRenderFns } from "./registration-steps.vue?vue&type=template&id=4100077a"
import script from "./registration-steps.vue?vue&type=script&lang=js"
export * from "./registration-steps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4100077a')) {
      api.createRecord('4100077a', component.options)
    } else {
      api.reload('4100077a', component.options)
    }
    module.hot.accept("./registration-steps.vue?vue&type=template&id=4100077a", function () {
      api.rerender('4100077a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/registration/components/registration-steps.vue"
export default component.exports